<template>
  <v-dialog
    :model-value="dialogModel"
    @update:model-value="updateDialog"
    transition="dialog-bottom-transition"
    max-width="600"
    persistent
  >
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar
          color="primary"
          dark
          flat
        >
          <v-toolbar-title>
            <v-icon
              size="medium"
              start
              >mdi-alert</v-icon
            >
            {{ $t('assign-leads.title') }}
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <!-- TODO: check unsupported prop: dark -->
            <v-btn
              icon
              @click="close"
            >
              <v-icon size="large">mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
      </v-card-title>

      <v-card-text class="mt-4">
        <p
          v-if="leadCount > 1"
          v-html="$t('assign-leads.dialog.assign-many', { amount: leadCount, userName })"
        />
        <p
          v-else
          v-html="$t('assign-leads.dialog.assign-one', { amount: leadCount, userName })"
        />
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn
          variant="text"
          @click="close"
        >
          {{ $t('labels.cancel') }}
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          @click="submit"
        >
          {{ $t('assign-leads.title') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  leadCount: {
    type: Number,
    default: 0,
  },
  userName: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['update:show', 'close', 'submit'])

const dialogModel = computed({
  get: () => props.show,
  set: (value) => emit('update:show', value),
})

const updateDialog = (value) => {
  dialogModel.value = value
}

const close = () => emit('close')
const submit = () => emit('submit')
</script>
